import React, { useEffect, useMemo, useState } from 'react';
import { API_BASE } from '../../../services/apiClient';
import i18n from '../../../i18n/config';
import { useCurrency } from '../../../contexts/CurrencyContext';
import { 
  Container, 
  Title, 
  Content, 
  Section, 
  Card, 
  CardHeader, 
  HeaderLeft,
  HeaderActions,
  SelectedInfo,
  SelectedPill,
  CardBody, 
  Table,
  ActionButton,
  IconButton,
  ModalOverlay,
  ModalCard,
  ModalHeader,
  ModalTitle,
  ModalBody,
  FormGrid,
  FormRow,
  Label,
  Input,
  Select,
  CheckboxRow,
  Checkbox,
  ModalActions,
  VerMaisButton 
} from './styles';
import { FaGlobe, FaCheck, FaPlus, FaTrashAlt, FaEdit } from 'react-icons/fa';

const PaginaTeste = () => {
  const { currency, currencySymbol, currenciesData } = useCurrency();
  const [moedas, setMoedas] = useState([]);
  const [dominios, setDominios] = useState([]);
  const [idiomas, setIdiomas] = useState([]);
  const [isLoadingDominios, setIsLoadingDominios] = useState(false);
  const [isLoadingCatalogos, setIsLoadingCatalogos] = useState(false);

  const [actionError, setActionError] = useState('');
  const [actionInfo, setActionInfo] = useState('');

  const [modalTipo, setModalTipo] = useState(null); // 'dominio'
  const [modalForm, setModalForm] = useState({});

  const toLabelStatus = (value) => {
    const v = String(value || '').toUpperCase();
    if (v === 'ATIVO') return 'Ativo';
    if (v === 'PENDENTE') return 'Pendente';
    if (v === 'INATIVO') return 'Inativo';
    if (v === 'EXPIRADO') return 'Expirado';
    return value || 'Ativo';
  };

  const toApiStatus = (value) => {
    const v = String(value || '').trim();
    const up = v.toUpperCase();
    if (['ATIVO', 'PENDENTE', 'INATIVO', 'EXPIRADO'].includes(up)) return up;
    if (v === 'Ativo') return 'ATIVO';
    if (v === 'Pendente') return 'PENDENTE';
    if (v === 'Inativo') return 'INATIVO';
    if (v === 'Expirado') return 'INATIVO';
    return 'ATIVO';
  };

  const normalizeDateToIso = (value) => {
    const v = String(value || '').trim();
    if (!v) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(v)) return v;
    const m = v.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (m) return `${m[3]}-${m[2]}-${m[1]}`;
    return null;
  };

  const formatDateToBR = (value) => {
    if (!value) return '';
    const v = String(value).trim();
    const m = v.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return v;
    return `${m[3]}/${m[2]}/${m[1]}`;
  };

  const toAbsoluteApiUrl = (path) => {
    const base = String(API_BASE || '').replace(/\/+$/, '');
    let p = String(path || '');
    if (!p.startsWith('/')) p = '/' + p;
    if (/\/api$/i.test(base) && /^\/api(\/|$)/i.test(p)) {
      p = p.replace(/^\/api/i, '');
    }
    return `${base}${p}`;
  };

  const requestJson = async (path, options) => {
    const baseUrl = toAbsoluteApiUrl(path);

    const doFetch = async (url) => {
      const res = await fetch(url, {
        headers: {
          'accept': 'application/json',
          'cache-control': 'no-cache',
          'pragma': 'no-cache',
          ...(options?.headers || {})
        },
        cache: 'no-store',
        ...options
      });
      return res;
    };

    let res = await doFetch(baseUrl);

    if (res.status === 304) {
      const sep = baseUrl.includes('?') ? '&' : '?';
      const busted = `${baseUrl}${sep}__ts=${Date.now()}`;
      res = await doFetch(busted);
    }

    const text = await res.text();
    let data = null;
    try { data = text ? JSON.parse(text) : null; } catch (_) { data = null; }
    if (!res.ok) {
      const msg = data?.message || data?.erro || text || `Erro ${res.status}`;
      throw new Error(msg);
    }
    return data;
  };

  const idiomasByCodigo = useMemo(() => {
    const m = new Map();
    (idiomas || []).forEach((i) => {
      const k = String(i?.codigo ?? '').trim();
      if (k) m.set(k, i?.nome || '');
    });
    return m;
  }, [idiomas]);

  const moedasById = useMemo(() => {
    const m = new Map();
    (moedas || []).forEach((mo) => {
      const k = String(mo?.id ?? '').trim();
      if (k) m.set(k, mo);
    });
    return m;
  }, [moedas]);

  const normalizeDominioRecord = (d) => {
    if (!d) return null;
    const idiomaId = d.idiomaDOMINIO ?? d.idioma ?? d.idiomaId ?? d.codigoIDIOMA ?? d.codigoIdioma ?? d.idIdioma;
    const moedaId = d.moedaDOMINIO ?? d.moeda ?? d.moedaId ?? d.codigoMOEDA ?? d.codigoMoeda ?? d.idMoeda;
    return {
      id: d.codigoDOMINIO ?? d.id ?? d.codigo ?? null,
      dominio: d.dominioDOMINIO ?? d.dominio ?? '',
      status: toLabelStatus(d.statusDOMINIO ?? d.status),
      expiracao: formatDateToBR(d.expiraEmDOMINIO ?? d.expiraEm ?? d.expiracao),
      principal: Boolean(d.principalDOMINIO ?? d.principal),
      idiomaId,
      idiomaNome: d?.idioma?.nomeIDIOMA ?? d?.Idioma?.nomeIDIOMA ?? d?.idiomaNome ?? d?.nomeIDIOMA ?? d?.idiomaNOME ?? '',
      moedaId,
      moedaIso: d?.moeda?.isoMOEDA ?? d?.Moeda?.isoMOEDA ?? d?.moedaIso ?? d?.isoMOEDA ?? '',
      moedaSimbolo: d?.moeda?.simboloMOEDA ?? d?.Moeda?.simboloMOEDA ?? d?.moedaSimbolo ?? d?.simboloMOEDA ?? '',
      moedaTipo: d?.moeda?.tipoMOEDA ?? d?.Moeda?.tipoMOEDA ?? d?.moedaTipo ?? d?.tipoMOEDA ?? ''
    };
  };

  const fetchDominios = async () => {
    setIsLoadingDominios(true);
    setActionError('');
    try {
      const data = await requestJson('/api/dominios-portal');
      const registros = Array.isArray(data?.Registros)
        ? data.Registros
        : (Array.isArray(data?.registros)
          ? data.registros
          : (Array.isArray(data?.data)
            ? data.data
            : (Array.isArray(data?.items)
              ? data.items
              : (Array.isArray(data?.result)
                ? data.result
                : (Array.isArray(data?.resultados)
                  ? data.resultados
                  : (Array.isArray(data) ? data : []))))));
      const normalized = registros.map(normalizeDominioRecord).filter(Boolean);
      setDominios(normalized);
      return normalized;
    } catch (e) {
      console.error('Erro ao carregar domínios', e);
      setActionError(String(e?.message || e || 'Erro ao carregar domínios'));
      return null;
    } finally {
      setIsLoadingDominios(false);
    }
  };

  const fetchCatalogos = async () => {
    setIsLoadingCatalogos(true);
    setActionError('');
    try {
      const moedasData = await requestJson('/api/moedas');

      const extractIdiomas = (data) => {
        const list = Array.isArray(data?.Registros)
          ? data.Registros
          : (Array.isArray(data?.registros)
            ? data.registros
            : (Array.isArray(data?.data)
              ? data.data
              : (Array.isArray(data?.items)
                ? data.items
                : (Array.isArray(data?.result)
                  ? data.result
                  : (Array.isArray(data?.resultados)
                    ? data.resultados
                    : (Array.isArray(data) ? data : []))))));

        return list
          .filter((i) => i && (i.codigoIDIOMA || i.nomeIDIOMA || i.id || i.codigo || i.nome))
          .map((i) => ({
            codigo: i.codigoIDIOMA ?? i.id ?? i.codigo,
            nome: i.nomeIDIOMA ?? i.nome ?? i.descricao ?? ''
          }));
      };

      const fetchFirstNonEmptyIdiomas = async () => {
        const candidates = ['/api/idiomas', '/idiomas', '/api/idioma', '/idioma'];
        for (const path of candidates) {
          try {
            const data = await requestJson(path);
            const normalized = extractIdiomas(data);
            if (normalized.length) return normalized;
          } catch (_) {
            // ignora e tenta próximo
          }
        }
        return [];
      };

      const idiomasNormalized = await fetchFirstNonEmptyIdiomas();
      setIdiomas(idiomasNormalized);

      const moedasReg = Array.isArray(moedasData?.Registros) ? moedasData.Registros : (Array.isArray(moedasData) ? moedasData : []);
      setMoedas(
        moedasReg
          .filter((m) => m && (m.codigoMOEDA || m.isoMOEDA))
          .map((m) => ({
            id: m.codigoMOEDA,
            iso: String(m.isoMOEDA || '').toUpperCase(),
            simbolo: String(m.simboloMOEDA || ''),
            tipo: String(m.tipoMOEDA || '')
          }))
      );
    } catch (e) {
      console.error('Erro ao carregar catálogos', e);
      setActionError(String(e?.message || e || 'Erro ao carregar catálogos'));
    } finally {
      setIsLoadingCatalogos(false);
    }
  };

  useEffect(() => {
    fetchCatalogos();
    fetchDominios();
  }, []);

  useEffect(() => {
    if (!idiomas.length && !moedas.length) return;
    setDominios((prev) => {
      if (!Array.isArray(prev) || prev.length === 0) return prev;
      return prev.map((d) => {
        const idiomaNome = d?.idiomaNome || idiomasByCodigo.get(String(d?.idiomaId ?? '').trim()) || '';
        const moedaLookup = moedasById.get(String(d?.moedaId ?? '').trim());
        const moedaIso = d?.moedaIso || moedaLookup?.iso || '';
        const moedaSimbolo = d?.moedaSimbolo || moedaLookup?.simbolo || '';
        const moedaTipo = d?.moedaTipo || moedaLookup?.tipo || '';
        if (idiomaNome === (d?.idiomaNome || '') && moedaIso === (d?.moedaIso || '') && moedaSimbolo === (d?.moedaSimbolo || '') && moedaTipo === (d?.moedaTipo || '')) {
          return d;
        }
        return {
          ...d,
          idiomaNome,
          moedaIso,
          moedaSimbolo,
          moedaTipo
        };
      });
    });
  }, [idiomas, moedas, idiomasByCodigo, moedasById]);

  const closeModal = () => {
    setModalTipo(null);
    setModalForm({});
  };

  const openModalDominio = () => {
    setModalTipo('dominio');
    setModalForm({ id: null, dominio: '', status: 'Ativo', expiracao: '', principal: false, idioma: '', moeda: '' });
  };

  const openModalEditarDominio = (item) => {
    setModalTipo('dominio');
    setModalForm({
      id: item?.id ?? null,
      dominio: item?.dominio ?? '',
      status: item?.status ?? 'Ativo',
      expiracao: item?.expiracao ? normalizeDateToIso(item.expiracao) || item.expiracao : '',
      principal: Boolean(item?.principal),
      idioma: item?.idiomaId ?? '',
      moeda: item?.moedaId ?? ''
    });
  };

  const ensureDefaultsForModal = () => {
    setModalForm((p) => {
      const next = { ...p };
      if (!next.status) next.status = 'Ativo';
      if (!next.idioma && idiomas.length) next.idioma = idiomas[0].codigo;
      if (!next.moeda && moedas.length) next.moeda = moedas[0].id;
      return next;
    });
  };

  const submitModal = (e) => {
    e.preventDefault();
    if (modalTipo === 'dominio') {
      (async () => {
        try {
          setActionError('');
          setActionInfo('');
          const dominio = String(modalForm.dominio || '').trim().toLowerCase();
          const status = toApiStatus(modalForm.status);
          const expiraEm = normalizeDateToIso(modalForm.expiracao);
          const principal = Boolean(modalForm.principal);
          const idioma = Number(modalForm.idioma) || null;
          const moeda = Number(modalForm.moeda) || null;

          if (!dominio) {
            setActionError('Preencha o domínio.');
            return;
          }
          if (!idioma) {
            setActionError('Selecione um idioma.');
            return;
          }
          if (!moeda) {
            setActionError('Selecione uma moeda.');
            return;
          }

          const payload = {
            dominio,
            status,
            expiraEm,
            idioma,
            moeda,
            principal
          };
          let savedResponse = null;
          if (modalForm.id) {
            savedResponse = await requestJson(`/api/dominios-portal/${modalForm.id}`, {
              method: 'PUT',
              headers: { 'content-type': 'application/json' },
              body: JSON.stringify(payload)
            });
          } else {
            savedResponse = await requestJson('/api/dominios-portal', {
              method: 'POST',
              headers: { 'content-type': 'application/json' },
              body: JSON.stringify(payload)
            });
          }

          closeModal();
          const list = await fetchDominios();

          if (!list || list.length === 0) {
            const record = normalizeDominioRecord(savedResponse) || normalizeDominioRecord({
              dominioDOMINIO: payload.dominio,
              statusDOMINIO: payload.status,
              expiraEmDOMINIO: payload.expiraEm,
              idiomaDOMINIO: payload.idioma,
              moedaDOMINIO: payload.moeda,
              principalDOMINIO: payload.principal
            });
            if (record) {
              const idiomaNomeLookup = idiomas.find((i) => String(i?.codigo) === String(record.idiomaId))?.nome;
              const moedaLookup = moedas.find((m) => String(m?.id) === String(record.moedaId));
              const recordEnriched = {
                ...record,
                idiomaNome: record.idiomaNome || idiomaNomeLookup || '',
                moedaIso: record.moedaIso || moedaLookup?.iso || '',
                moedaSimbolo: record.moedaSimbolo || moedaLookup?.simbolo || '',
                moedaTipo: record.moedaTipo || moedaLookup?.tipo || ''
              };
              setDominios((prev) => {
                const next = Array.isArray(prev) ? prev.slice() : [];
                const exists = next.some((d) => String(d?.id) === String(recordEnriched?.id) || String(d?.dominio || '') === String(recordEnriched?.dominio || ''));
                if (!exists) next.unshift(recordEnriched);
                return next;
              });
            }
          }

          setActionInfo(modalForm.id ? 'Domínio atualizado.' : 'Domínio cadastrado.');
        } catch (err) {
          console.error('Erro ao salvar domínio', err);
          setActionError(String(err?.message || err || 'Erro ao salvar domínio'));
        }
      })();
      return;
    }

  };

  const handleDeleteDominio = (dominio) => {
    (async () => {
      const id = typeof dominio === 'object' ? dominio?.id : null;
      const label = typeof dominio === 'object' ? dominio?.dominio : dominio;
      const ok = window.confirm(`Excluir o domínio ${label}?`);
      if (!ok) return;
      if (!id) {
        setActionError('Não foi possível identificar o registro para exclusão.');
        return;
      }
      try {
        setActionError('');
        setActionInfo('');
        await requestJson(`/api/dominios-portal/${id}`, { method: 'DELETE' });
        await fetchDominios();
        setActionInfo('Domínio excluído.');
      } catch (e) {
        console.error('Erro ao excluir domínio', e);
        setActionError(String(e?.message || e || 'Erro ao excluir domínio'));
      }
    })();
  };

  const [mostrarTodosDominios, setMostrarTodosDominios] = useState(false);

  const limiteTabela = 5;

  const dominiosVisiveis = useMemo(
    () => (mostrarTodosDominios ? dominios : dominios.slice(0, limiteTabela)),
    [mostrarTodosDominios, dominios]
  );

  const getStatusBadge = (status) => {
    const statusMap = {
      'Ativo': { bg: '#e6f7ee', color: '#10b981' },
      'Inativo': { bg: '#fee2e2', color: '#ef4444' },
      'Expirado': { bg: '#fef3c7', color: '#d97706' }
    };
    
    const style = statusMap[status] || { bg: '#e5e7eb', color: '#4b5563' };
    
    return (
      <span style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '0.25rem 0.75rem',
        borderRadius: '9999px',
        backgroundColor: style.bg,
        color: style.color,
        fontSize: '0.75rem',
        fontWeight: 600
      }}>
        {status}
      </span>
    );
  };

  return (
    <Container>
      <Title>Configurações do Sistema</Title>

      {modalTipo && (
        <ModalOverlay onMouseDown={(e) => {
          if (e.target === e.currentTarget) closeModal();
        }}>
          <ModalCard>
            <ModalHeader>
              <ModalTitle>{modalForm?.id ? 'Editar Domínio' : 'Adicionar Domínio'}</ModalTitle>
              <ActionButton type="button" onClick={closeModal}>Fechar</ActionButton>
            </ModalHeader>

            <ModalBody>
              <form onSubmit={submitModal}>
                {modalTipo === 'dominio' && (
                  <FormGrid>
                    <FormRow>
                      <Label>Domínio</Label>
                      <Input value={modalForm.dominio || ''} onChange={(e) => setModalForm((p) => ({ ...p, dominio: e.target.value }))} placeholder="joviplanet.com.br" />
                    </FormRow>
                    <FormRow>
                      <Label>Status</Label>
                      <Select value={modalForm.status || 'Ativo'} onChange={(e) => setModalForm((p) => ({ ...p, status: e.target.value }))}>
                        <option value="Ativo">Ativo</option>
                        <option value="Inativo">Inativo</option>
                        <option value="Pendente">Pendente</option>
                        <option value="Expirado">Expirado</option>
                      </Select>
                    </FormRow>
                    <FormRow>
                      <Label>Idioma</Label>
                      <Select
                        value={modalForm.idioma || (idiomas[0]?.codigo || '')}
                        onFocus={ensureDefaultsForModal}
                        onChange={(e) => setModalForm((p) => ({ ...p, idioma: e.target.value }))}
                      >
                        <option value="" disabled>
                          {isLoadingCatalogos ? 'Carregando...' : 'Selecione'}
                        </option>
                        {idiomas.map((i) => (
                          <option key={i.codigo} value={i.codigo}>{i.codigo} - {i.nome}</option>
                        ))}
                      </Select>
                    </FormRow>
                    <FormRow>
                      <Label>Moeda</Label>
                      <Select
                        value={modalForm.moeda || (moedas[0]?.id || '')}
                        onFocus={ensureDefaultsForModal}
                        onChange={(e) => setModalForm((p) => ({ ...p, moeda: e.target.value }))}
                      >
                        {moedas.map((m) => (
                          <option key={m.id} value={m.id}>{m.iso}{m.simbolo ? ` - ${m.simbolo}` : ''}{m.tipo ? ` (${m.tipo})` : ''}</option>
                        ))}
                      </Select>
                    </FormRow>
                    <FormRow>
                      <Label>Expira em</Label>
                      <Input type="date" value={modalForm.expiracao || ''} onChange={(e) => setModalForm((p) => ({ ...p, expiracao: e.target.value }))} />
                    </FormRow>
                    <FormRow>
                      <Label>Principal</Label>
                      <CheckboxRow>
                        <Checkbox type="checkbox" checked={Boolean(modalForm.principal)} onChange={(e) => setModalForm((p) => ({ ...p, principal: e.target.checked }))} />
                        Marcar como principal
                      </CheckboxRow>
                    </FormRow>
                  </FormGrid>
                )}

                <ModalActions>
                  <ActionButton type="button" onClick={closeModal}>Cancelar</ActionButton>
                  <ActionButton type="submit">Salvar</ActionButton>
                </ModalActions>
              </form>
            </ModalBody>
          </ModalCard>
        </ModalOverlay>
      )}
      
      <Content>
        <Section>
          <Card>
            <CardHeader>
              <HeaderLeft>
                <FaGlobe style={{ marginRight: '0.5rem' }} />
                Domínios
              </HeaderLeft>

              <HeaderActions>
                <SelectedInfo>
                  <SelectedPill>
                    <span>Idioma:</span>
                    {String(i18n?.language || 'pt-PT')}
                  </SelectedPill>
                  <SelectedPill>
                    <span>Moeda:</span>
                    {(() => {
                      const iso = String(currency || '').toUpperCase();
                      const fromCtx = currencySymbol ? `${iso} - ${currencySymbol}` : iso;
                      if (fromCtx.trim()) return fromCtx;
                      const found = (currenciesData || []).find((m) => String(m?.isoMOEDA || '').toUpperCase() === iso);
                      if (found?.isoMOEDA) return `${String(found.isoMOEDA).toUpperCase()} - ${String(found.simboloMOEDA || '')}`;
                      return 'EUR - €';
                    })()}
                  </SelectedPill>
                </SelectedInfo>
                <ActionButton type="button" onClick={openModalDominio}>
                  <FaPlus />
                  Adicionar
                </ActionButton>
              </HeaderActions>
            </CardHeader>
            <CardBody>
              {!!actionError && (
                <div style={{ padding: '10px 12px', marginBottom: 12, borderRadius: 8, background: '#fee2e2', color: '#991b1b', fontWeight: 600 }}>
                  {actionError}
                </div>
              )}
              {!actionError && !!actionInfo && (
                <div style={{ padding: '10px 12px', marginBottom: 12, borderRadius: 8, background: '#e6f7ee', color: '#065f46', fontWeight: 600 }}>
                  {actionInfo}
                </div>
              )}
              <Table>
                <thead>
                  <tr>
                    <th>Domínio</th>
                    <th>Status</th>
                    <th>Expira em</th>
                    <th>Idioma</th>
                    <th>Moeda</th>
                    <th>Principal</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoadingDominios && (
                    <tr>
                      <td colSpan={7} style={{ padding: '12px' }}>Carregando domínios...</td>
                    </tr>
                  )}

                  {!isLoadingDominios && dominiosVisiveis.length === 0 && (
                    <tr>
                      <td colSpan={7} style={{ padding: '12px' }}>Nenhum domínio cadastrado.</td>
                    </tr>
                  )}

                  {!isLoadingDominios && dominiosVisiveis.map((dominio, index) => (
                    <tr key={dominio.id ?? index}>
                      <td>{dominio.dominio}</td>
                      <td>{getStatusBadge(dominio.status)}</td>
                      <td>{dominio.expiracao}</td>
                      <td>
                        {(() => {
                          const nome = dominio.idiomaNome || idiomasByCodigo.get(String(dominio.idiomaId ?? '').trim());
                          if (nome) return nome;
                          return '—';
                        })()}
                      </td>
                      <td>
                        {(() => {
                          const parts = [];
                          if (dominio.moedaIso) parts.push(dominio.moedaIso);
                          if (dominio.moedaSimbolo) parts.push(dominio.moedaSimbolo);
                          if (!parts.length && dominio.moedaId) parts.push(String(dominio.moedaId));
                          return parts.join(' - ');
                        })()}
                      </td>
                      <td>
                        {dominio.principal && (
                          <FaCheck style={{ color: '#10b981' }} />
                        )}
                      </td>
                      <td>
                        <IconButton type="button" onClick={() => openModalEditarDominio(dominio)} aria-label={`Editar ${dominio.dominio}`}>
                          <FaEdit />
                        </IconButton>
                        <IconButton type="button" onClick={() => handleDeleteDominio(dominio)} aria-label={`Excluir ${dominio.dominio}`}>
                          <FaTrashAlt />
                        </IconButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {dominios.length > limiteTabela && (
                <VerMaisButton type="button" onClick={() => setMostrarTodosDominios((prev) => !prev)}>
                  {mostrarTodosDominios ? 'Ver menos' : 'Ver mais'}
                </VerMaisButton>
              )}
            </CardBody>
          </Card>
        </Section>
      </Content>
    </Container>
  );
};

export default PaginaTeste;
